import { useNavigate, Link } from 'react-router-dom'
import { Menu, LogOut, User, Settings, Crown, UserCog } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuth } from '@/contexts/AuthContext'

interface HeaderProps {
  username: string
  role: string
  onMenuClick: () => void
}

export function Header({ username, role, onMenuClick }: HeaderProps) {
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="flex h-16 items-center justify-between border-b bg-card px-4">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <h2 className="text-lg font-semibold lg:hidden">SES Manager</h2>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground outline-none">
          {role === 'admin' ? (
            <Crown className="h-5 w-5 text-amber-500" />
          ) : role === 'write' ? (
            <UserCog className="h-5 w-5 text-blue-500" />
          ) : (
            <User className="h-5 w-5" />
          )}
          <span className="hidden sm:inline">{username}</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <div className="px-2 py-1.5">
            <p className="text-sm font-medium">{username}</p>
            <p className="text-xs text-muted-foreground capitalize">{role}</p>
          </div>
          <DropdownMenuSeparator />
          <Link to="/dashboard/profile">
            <DropdownMenuItem className="cursor-pointer">
              <Settings className="mr-2 h-4 w-4" />
              Profile
            </DropdownMenuItem>
          </Link>
          <DropdownMenuItem onClick={handleLogout} variant="destructive" className="cursor-pointer">
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  )
}
